import http from "./httpService";
import Moment from "moment";

const apiEndpoint = process.env.REACT_APP_API_IDENTITY_URL + "/users";

export async function CreateUser(data) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint, data);
}
export async function GetUserGroupList() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/userGroup");
}
export async function GetUserGroupsWithLogo() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/GetUserGroupsWithLogo");
}
export async function EditUser(data) {
    http.addBearerAuthorization();
    return await http.put(apiEndpoint + "/" + data.id, data);
}

export async function DeleteUser(id) {
    http.addBearerAuthorization();
    return await http.delete(encodeURI(apiEndpoint + "/" + id));
}

export async function GetUser(id) {
    id = id.toUpperCase();
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/" + id);
}

export async function GetUserByRoleName(roleName) {
    http.addBearerAuthorization();
    return await http.get(`${apiEndpoint}/GetUsersByRoleName?rolename=${roleName}`);
}

export async function TransferUser(fromUserId, toUserId) {
    http.addBearerAuthorization();
    return await http.post(`${apiEndpoint}/TransferUser`, {
      fromUserId: fromUserId,
      toUserId: toUserId,
    });
}

export async function GetCurrentUserDetails() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint);
}

export async function GetUsers() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint);
}

export async function GetUsersByMarket() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/market");
}

export async function GetUsersByParentUser() {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/parentuser");
}

export async function GetUsersByRoleAndMarket(role, market_ids) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/GetUsersByRoleAndMarkets?role=" + role , market_ids);
}

export async function SearchUsers(text, limit, offset) {
    http.addBearerAuthorization();
    var url = apiEndpoint + "/search/" + text;

    if (limit !== undefined) url += +"/" + limit;
    if (offset !== undefined) url += +"/" + offset;

    return await http.get(url);
}

export async function SendEmailConfirmation(data) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/SendEmailConfirmation", data);
}

export async function UpdateUserDetails(userDetails) {
    http.addBearerAuthorization();
    return await http.put(apiEndpoint, { userDetails });
}

export async function GetLoginHistories(data) {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/histories/" + Moment(data.start_date).format("YYYY-MM-DDTHH:mm") + "/" + Moment(data.end_date).format("YYYY-MM-DDTHH:mm"));
}

export async function GetUsersHistories(data) {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/histories/" + data.market_id + "/" + Moment(data.start_date).format("YYYY-MM-DDTHH:mm") + "/" + Moment(data.end_date).format("YYYY-MM-DDTHH:mm"));
}

export async function LoginHistoriesReport(user_id) {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/report/loginhistories/" + user_id);
}

export async function LoginSummaryHistoriesReport(market_id) {
    http.addBearerAuthorization();
    return await http.get(apiEndpoint + "/report/loginhistories/summary/" + market_id);
}
export async function CreateUpdateUserGroup(data) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + "/CreateUpdateUserGroup" ,data);
}
export async function getUserGroupById(id) {
    http.addBearerAuthorization();
    return await http.post(apiEndpoint + `/GetUserGroupByGroupId?userGroupId=${id}`,{});
}

export default {
    CreateUser,
    EditUser,
    DeleteUser,
    UpdateUserDetails,
    GetUser,
    GetUserByRoleName,
    TransferUser,
    GetCurrentUserDetails,
    GetUserGroupList,
    GetUsers,
    GetUsersByMarket,
    GetUsersByRoleAndMarket,
    GetUsersByParentUser,
    SearchUsers,
    SendEmailConfirmation,
    GetUsersHistories,
    LoginHistoriesReport,
    GetLoginHistories,
    LoginSummaryHistoriesReport,
    CreateUpdateUserGroup,
    getUserGroupById,
    GetUserGroupsWithLogo
};
